<template>
  <div v-if="!$route.meta.noSearch" class="f-ac header-search-view">
    <el-select
      v-model="searchType"
      placeholder="请选择"
      class="primary-selected"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-input
      style="width: 388px"
      v-model="searchValue"
      placeholder="请输入您要搜索的关键词"
      clearable
      @keyup.enter.native="search"
    />
    <el-button type="primary" class="my-search-btn" @click="search"
      >搜索</el-button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SEARCH_TYPE_OPTIONS } from "@/utils/constant";

export default {
  name: "HeadSearch",
  components: {},
  props: {},
  data() {
    return {
      searchType: "all",
      searchValue: "",
      options: SEARCH_TYPE_OPTIONS,
    };
  },
  computed: {
    ...mapGetters(["site", "allMenusList"]),
    searchPath() {
      const searchItem =
        this.allMenusList.find((m) => m.code === this.searchType) || {};
      return searchItem.path;
    },
  },
  watch: {
    searchType(v) {
      sessionStorage.setItem("searchType", v);
    },
  },
  created() {},
  mounted() {
    this.searchType = sessionStorage.getItem("searchType") || "all";
  },
  methods: {
    search() {
      if (this.searchType === "all") {
        window.open(`/web/search?title=${this.searchValue}`);
        return;
      }
      this.$router.push({
        path: this.searchPath,
        query: {
          title: this.searchValue,
          t: Date.now(),
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header-search-view {
  width: 500px;
  height: 50px;
  border: 2px solid $--color-primary;

  :deep(.el-input),
  :deep(.el-input__inner) {
    height: 46px;
    line-height: 44px;
    border: none;
  }

  :deep(.primary-selected) {
    width: 90px;
    flex-shrink: 0;

    .el-input {
      .el-input__inner {
        text-align: center;
        color: #999;
        padding-left: 10px;
        padding-right: 25px;
        font-weight: normal;
        background-color: #f5f5f5;
      }
      .el-input__suffix {
        right: 8px;
        .el-input__icon {
          height: 46px;
          line-height: 46px;
          width: 100%;
          color: #999;
          font-size: 12px;
        }
      }
    }
  }

  .my-search-btn {
    width: 100px;
    height: 100%;
    flex-shrink: 0;
    border-radius: 0;
  }
}
</style>
